import { AuthApiProvider } from 'src/provider/API/v2/call-service/Auth'
import { ConfigurationApiProvider } from 'src/provider/API/v2/call-service/configuration'
import { CustomerApiProvider } from 'src/provider/API/v2/call-service/Customer/index'
import { SurveyApiProvider } from 'src/provider/API/v2/call-service/Survey'
import { DashboardLayout } from 'src/app/dashboardv2/layout/DashboardLayout'
import '@fontsource/poppins/400.css'
import '@fontsource/inter/500.css'

const DashboardV2 = () => {
    return (
        <AuthApiProvider>
            <ConfigurationApiProvider>
                <CustomerApiProvider>
                    <SurveyApiProvider>
                        <div className="dashboard-v2" style={{ width: '100%', minHeight: '100vh' }}>
                            <DashboardLayout />
                        </div>
                    </SurveyApiProvider>
                </CustomerApiProvider>
            </ConfigurationApiProvider>
        </AuthApiProvider>
    )
}

export default DashboardV2